import { map } from "lodash";
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
    Modal,
    ModalBody
} from "reactstrap";
import SecureLS from "secure-ls";
import {
    setBusy,
    setDisplayLogin,
    setIdle,
    setIsShowCreateShareHolderPin,
    setIsShowVerifyShareHolderPin,
    setCommunicationChannelList,
    setRtpUrl,
    showMessage,
    setDisplayProfile,
    setIsNonSeamlessGameExist,
    showResponseMessage,
    setProductCategoryGameList,
    setIsShowBigWinning,
    setIsShowCreateShareHolderPinPopup
} from "../../redux/AppAction";
import { performLogout, updateUserSpecialRollover, updateUserRolloverBalance, updateUserIsCreateShareHolderPin } from "../../redux/AuthAction.js";
import { saveLanguageId } from "../../redux/LanguageAction";
import ApiEngine from "../../util/ApiEngine.js";
import {
    ApiKey,
    ApiUrl,
    Language,
    LanguageOption,
    SessionKey,
    WebUrl
} from "../../util/Constant";
import { createFormBody } from "../../util/Util.js";
import Auth from "../auth/Auth.js";
import ShareHolderAuth from "../auth/ShareHolderAuth";
import NonSeamlessGameWalletModal from "../wallet/NonSeamlessGameWalletModal";
import { setPlayableCategory, setProductCategory, setRolloverTarget } from "../../redux/GameAction.js";
import BigWinningModal from "../big-winning/BigWinningModal";
import { CacheKeys, getSessionCache, setSessionCache } from "../../util/HomeDataCache.js";


/**
 * Author: -
 */
const Header = React.forwardRef((props, ref) => {
    const {
        data,
    } = props;
    const { t, i18n } = useTranslation();
    const _dispatch = useDispatch();
    const _history = useHistory();
    const location = useLocation();
    const search = window.location.search;
    const params = new URLSearchParams(search);

    // ***** global state *****

    const { isLoggedIn } = useSelector((state) => state.authState);
    const _userData = useSelector((state) => state.authState.userData);
    const rtpUrl = useSelector((state) => state.appState.rtpUrl);
    const ProductCategoryGameList = useSelector((state) => state.appState.productCategoryGameList);
    let isNonSeamlessGameExist = useSelector((state) => state.appState.isNonSeamlessGameExist);
    const { productCategory, rolloverTarget, playableCategory } = useSelector((state) => state.gameState);

    // ***** local state *****
    const [selectionLangHeaderOption, setSelectionLangHeaderOption] = useState([]);
    const [activeLanguage, setActiveLanguage] = useState("id");
    const [navVisible, setNavVisible] = useState(false);
    const [showNavCountry, setShowNavCountry] = useState(false);
    const [showNavOfficialLinks, setShowNavOfficialLinks] = useState(false);
    const [selectedSubMenu, setSelectedSubMenu] = useState(0);
    const [companyOfficialLinks, setCompanyOfficialLinks] = useState([]);
    const [displayOfficialLinks, setDisplayOfficialLinks] = useState([]);
    const countryList = [
        {
            name: "Indonesia",
            iso: "ID",
            icon: "/img/v3/id.png",
            icon_circle: "/img/v3/id-circle.png",
            url: window.location.origin,
            child_languages: [
                {
                    name: "Indo",
                    languageCode: Language._INDON,
                    languageId: 7
                },
                {
                    name: "English",
                    languageCode: Language._ENGLISH,
                    languageId: 1
                },
            ],
        },
        {
            name: "Malaysia",
            iso: "MYR",
            icon: "/img/v3/my.png",
            icon_circle: "/img/v3/my-circle.png",
            url: (window.location.href).includes("staging") ? 'https://my-staging.huat8my.com/' : (window.location.href).includes("preproduction") ? 'https://my-preproduction.huat8my.com/' : 'https://m.i8my.live/',
            child_languages: [
                {
                    name: "English",
                    languageCode: Language._ENGLISH,
                    languageId: 1
                },
                {
                    name: "中文",
                    languageCode: Language._CHINESE,
                    languageId: 2
                },
                {
                    name: "Malay",
                    languageCode: Language._BAHASA_MELAYU,
                    languageId: 3
                },
                {
                    name: "ไทย",
                    languageCode: Language._THAI,
                    languageId: 5
                },
                {
                    name: "Tiếng Việt",
                    languageCode: Language._VIETNAMESE,
                    languageId: 6
                },
                {
                    name: "Indo",
                    languageCode: Language._INDON,
                    languageId: 7
                }
            ],
        },
        {
            name: "Thailand",
            iso: "TH",
            icon: "/img/v3/th.png",
            icon_circle: "/img/v3/th-circle.png",
            url: (window.location.href).includes("staging") ? 'https://th-staging.huat8th.com' : (window.location.href).includes("preproduction") ? 'https://th-preproduction.huat8th.com' : 'https://m.i8th.live',
            child_languages: [
                {
                    name: "ไทย",
                    languageCode: Language._THAI,
                    languageId: 5
                },
                {
                    name: "English",
                    languageCode: Language._ENGLISH,
                    languageId: 1
                },
                {
                    name: "中文",
                    languageCode: Language._CHINESE,
                    languageId: 2
                },
                {
                    name: "Malay",
                    languageCode: Language._BAHASA_MELAYU,
                    languageId: 3
                },
                {
                    name: "Tiếng Việt",
                    languageCode: Language._VIETNAMESE,
                    languageId: 6
                },
                {
                    name: "Indo",
                    languageCode: Language._INDON,
                    languageId: 7
                }
            ],
        },
        //{
        //    name: "Australia",
        //    iso: "AU",
        //    icon: "/img/v3/au.png",
        //    icon_circle: "/img/v3/au-circle.png",
        //    url: (window.location.href).includes("staging") ? 'https://au-staging.huat8au.com' : (window.location.href).includes("preproduction") ? 'https://au-preproduction.huat8au.com' : 'https://m.i8au.live',
        //    child_languages: [
        //        {
        //            name: "English",
        //            languageCode: Language._ENGLISH,
        //            languageId: 1
        //        },
        //        {
        //            name: "中文",
        //            languageCode: Language._CHINESE,
        //            languageId: 2
        //        },
        //        {
        //            name: "Malay",
        //            languageCode: Language._BAHASA_MELAYU,
        //            languageId: 3
        //        },
        //        {
        //            name: "ไทย",
        //            languageCode: Language._THAI,
        //            languageId: 5
        //        },
        //        {
        //            name: "Tiếng Việt",
        //            languageCode: Language._VIETNAMESE,
        //            languageId: 6
        //        },
        //        {
        //            name: "Indo",
        //            languageCode: Language._INDON,
        //            languageId: 7
        //        }
        //    ],
        //},
    ];
    const newNavList = [
        {
            title: t("HOME"),
            icon: "/img/ug/sidemenu/home.svg",
            url: WebUrl._URL_MAIN,
            hot: false,
            new: false,
            openNewWindow: false,
            requiredAuth: false,
            onActivePage: true,
        },
        {
            title: t("GAMES"),
            icon: "/img/ug/sidemenu/games.svg",
            url: "",
            hot: false,
            new: false,
            openNewWindow: false,
            requiredAuth: false,
            onActivePage: true,
            subList: ProductCategoryGameList, //go to UGGetActiveGameCategory() in UG Service if any changes needed
            subMenuId: 1
        },
        {
            title: t("FUND"),
            icon: "/img/ug/sidemenu/fund.svg",
            url: "",
            hot: false,
            new: false,
            openNewWindow: false,
            requiredAuth: true,
            onActivePage: true,
            subList: [
                {
                    title: t("DEPOSIT"),
                    icon: "/img/ug/sidemenu/deposit-mobile-ug.svg",
                    originalTitle: "Deposit",
                    hot: false,
                    new: false,
                    url: WebUrl._URL_DEPOSIT,
                    requiredAuth: false,
                    openNewWindow: false,
                    onActivePage: true,
                    isDisplay: true,
                },
                {
                    title: t("WITHDRAWAL"),
                    icon: "/img/ug/sidemenu/withdraw-ug.svg",
                    originalTitle: "Withdrawal",
                    hot: false,
                    new: false,
                    url: WebUrl._URL_WITHDRAWAL,
                    requiredAuth: false,
                    openNewWindow: false,
                    onActivePage: true,
                    isDisplay: _userData && _userData.isBlockWithdraw ? false : true,
                },
                //{
                //  title: t("TRANSFER"),
                //  icon: "/img/ug/sidemenu/transfer-ug.svg",
                //  originalTitle: "Transfer",
                //  hot: false,
                //  new: false,
                //  url: WebUrl._URL_TRANSFER,
                //  requiredAuth: false,
                //  openNewWindow: false,
                //  onActivePage: true,
                //  isDisplay: isNonSeamlessGameExist,
                //},
                {
                    title: t("STATEMENT"),
                    icon: "/img/ug/sidemenu/statement-ug.svg",
                    originalTitle: "Statement",
                    hot: false,
                    new: false,
                    url: WebUrl._URL_STATEMENT,
                    requiredAuth: false,
                    openNewWindow: false,
                    onActivePage: true,
                    isDisplay: true,
                },
            ],
            subMenuId: 2
        },
        {
            title: t("MY_WALLET"),
            icon: "/img/ug/sidemenu/wallet.svg",
            url: "",
            hot: false,
            new: false,
            openNewWindow: false,
            requiredAuth: true,
            onActivePage: true,
            subList: [{
                title: t("LOYALTY_REDEMPTION"),
                icon: "/img/ug/sidemenu/loyalty.svg",
                url: WebUrl._URL_LOYALTY_REDEMPTION,
                hot: false,
                new: false,
                openNewWindow: false,
                requiredAuth: true,
                onActivePage: true,
                isDisplay: true,
            },
            {
                title: t("REWARDS"),
                icon: "/img/ug/sidemenu/rewards.svg",
                url: WebUrl._URL_REWARDS,
                hot: false,
                new: false,
                openNewWindow: false,
                requiredAuth: true,
                onActivePage: true,
                isDisplay: true,
            },
            {
                title: t("COMMISSION"),
                icon: "/img/ug/sidemenu/commission.svg",
                url: WebUrl._URL_UNCLAIM_COMMISSION_HISTORY,
                hot: false,
                new: false,
                openNewWindow: false,
                requiredAuth: true,
                onActivePage: true,
                isDisplay: true,
            },],
            subMenuId: 3
        },
        {
            title: t("MY_PROMO"),
            icon: "/img/ug/sidemenu/my-promo.svg",
            url: WebUrl._URL_MY_PROMO,
            hot: false,
            new: false,
            openNewWindow: false,
            requiredAuth: true,
            onActivePage: true
        },
        {
            title: t("REPORT"),
            icon: "/img/ug/sidemenu/report.svg",
            url: WebUrl._URL_TRANSACTION_HISTORY,
            hot: false,
            new: false,
            openNewWindow: false,
            requiredAuth: true,
            onActivePage: true
        },
        {
            title: t("VIP_EVENT"),
            icon: "/img/ug/sidemenu/vip.svg",
            url: WebUrl._URL_SHAREHOLDER,
            hot: false,
            new: false,
            openNewWindow: false,
            requiredAuth: true,
            onActivePage: true,
            isVip: true
        },
        {
            title: t("KPI"),
            icon: "/img/ug/sidemenu/KPI.svg",
            url: WebUrl._URL_KPI,
            hot: false,
            new: false,
            openNewWindow: false,
            requiredAuth: true,
            onActivePage: true,
        },
        {
            title: t("PROMOTION"),
            icon: "/img/ug/sidemenu/promotion.svg",
            url: WebUrl._URL_PROMOTION,
            hot: false,
            new: false,
            openNewWindow: false,
            requiredAuth: false,
            onActivePage: true,
        },
        {
            title: t("AFFILIATE"),
            icon: "/img/ug/sidemenu/affiliate.svg",
            url: WebUrl._URL_AFFILIATE_PARTNER_PROGRAM,
            hot: false,
            new: false,
            openNewWindow: false,
            requiredAuth: false,
            onActivePage: true,
        },
        {
            title: t("RTP LIVE"),
            icon: "/img/ug/sidemenu/rtp-live.svg",
            url: rtpUrl,
            hot: false,
            new: false,
            openNewWindow: true,
            requiredAuth: false,
            onActivePage: false,
        },
        {
            title: t("BIG_WINNING"),
            icon: "/img/ug/sidemenu/winning.gif",
            url: "",
            hot: false,
            new: false,
            openNewWindow: false,
            requiredAuth: false,
            onActivePage: false,
            isBigWinning: true
        },
        {
            title: t("HOW_TO_PLAY"),
            icon: "/img/ug/sidemenu/how-to-play.svg",
            url: WebUrl._URL_HOW_TO_PLAY,
            hot: false,
            new: false,
            openNewWindow: false,
            requiredAuth: false,
            onActivePage: true
        },
        {
            title: t("FAQ"),
            icon: "/img/ug/sidemenu/help.svg",
            url: WebUrl._URL_FAQ,
            hot: false,
            new: false,
            openNewWindow: false,
            requiredAuth: false,
            onActivePage: true,
        },
        {
            title: t("LANGUAGE"),
            icon: "/img/ug/sidemenu/language.svg",
            url: "",
            hot: false,
            new: false,
            openNewWindow: false,
            requiredAuth: false,
            onActivePage: false,
            isLang: true
        },
        {
            title: t("OFFICIAL_LINK"),
            icon: "/img/ug/sidemenu/link.svg",
            url: "",
            hot: false,
            new: false,
            openNewWindow: false,
            requiredAuth: false,
            onActivePage: false,
            isOfficialLink: true
        },
        {
            title: t("LOGOUT"),
            icon: "/img/ug/sidemenu/logout.svg",
            url: "",
            hot: false,
            new: false,
            openNewWindow: false,
            requiredAuth: true,
            onActivePage: false,
            isLogout: true
        },
    ]
    const specialRolloverInterval = useRef(null);
    const [firstLoad, setFirstLoad] = useState(true);

    // ***** useEffect *****
    useEffect(() => {
        let initSelectionOption = countryList.filter(x => x.iso == "ID")[0];
        setSelectionLangHeaderOption(initSelectionOption);
        checkInitialLanguage();
        getMobileHeaderGeneralData();
    }, []);

    useEffect(() => {
        if (!firstLoad) {
            getMobileHeaderAuthData();
            if (!isLoggedIn) {
                clearInterval(specialRolloverInterval.current);
                _dispatch(setPlayableCategory([]));
                _dispatch(setRolloverTarget(0));
            }
        }
        
        if (isLoggedIn) {
            if (_userData.isShareHolder && _userData.isCreateShareHolderPin) {
                _dispatch(setIsShowCreateShareHolderPinPopup(true));
            }
            if (!_userData.seeHiddenGames) {
                let tempCompanyOfficialLinks = companyOfficialLinks.filter(x => !x.testing);
                setDisplayOfficialLinks(tempCompanyOfficialLinks);
            }
            else {
              setDisplayOfficialLinks(companyOfficialLinks);
            }
        }
        else {
          let tempCompanyOfficialLinks = companyOfficialLinks.filter(x => !x.testing);
          setDisplayOfficialLinks(tempCompanyOfficialLinks);
        }


        return () => {
            clearInterval(specialRolloverInterval.current);
        };
    }, [isLoggedIn]);

    useEffect(() => {
        if (isLoggedIn && _userData && _userData.isSpecialRollover && productCategory.length > 0) {
            getRolloverData();
            getBonusDepositProductCategory();
            clearInterval(specialRolloverInterval.current);
            specialRolloverInterval.current = setInterval(getMemberSpecialRollover, 5000);
        } else {
            clearInterval(specialRolloverInterval.current);
            _dispatch(setPlayableCategory([]));
            _dispatch(setRolloverTarget(0));
        }
    }, [_userData.isSpecialRollover, productCategory])

    useEffect(() => {
        if (isLoggedIn && _userData && _userData.rolloverBalance === 0) {
            _dispatch(setRolloverTarget(0));
        }
    }, [_userData.rolloverBalance])

    useEffect(() => {
        if (!firstLoad) {
            getMobileHeaderLanguageData();
        }
    }, [i18n.language]);

    // ***** function *****

    const handleCountryOnClick = async (countryItem, selectedLanguage) => {
        if (typeof (selectedLanguage) !== "undefined") {
            changeLanguage(selectedLanguage);
        }
        if (countryItem.url !== window.location.origin) {
            await _dispatch(performLogout());

            let redirectUrl = countryItem.url + "?languageCode=" + (typeof (selectedLanguage) !== "undefined" ? selectedLanguage : "id");
            if (window.ReactNativeWebView) {
                const splitUrl = redirectUrl.split(".");

                let mobileRedirectUrl = "";

                if (splitUrl[1].match("live/")) {
                    if (splitUrl[0].match("https://m") === null) {
                        mobileRedirectUrl = redirectUrl.replace("https://", 'https://m.');
                    }
                    else {
                        mobileRedirectUrl = redirectUrl;
                    }
                }
                else {
                    mobileRedirectUrl = redirectUrl;
                }

                window.ReactNativeWebView.postMessage(
                    JSON.stringify({
                        action: "changeCountry",
                        countryUrl: mobileRedirectUrl,
                    })
                );
            }
            window.location.assign(redirectUrl);
        }
        setShowNavCountry(false);
    }

    const changeLanguage = async (selectedLanguage) => {
        i18n.changeLanguage(selectedLanguage);
        _dispatch(saveLanguageId(selectedLanguage));
        localStorage.setItem(SessionKey._LANGUAGE, selectedLanguage);
        setActiveLanguage(selectedLanguage);
        if (isLoggedIn) {
            let params =
            {
                "languageSetting": selectedLanguage
            };
            let langJson = await ApiEngine.post(ApiUrl._API_UPDATE_MEMBER_LANGUAGE, createFormBody(params));
            if (!langJson[ApiKey._API_SUCCESS_KEY]) {
                _dispatch(showMessage(false, t("ERROR_SAVING_LANGUAGE_TO_MEMBER")));
            }

            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(
                    JSON.stringify({
                        action: "language",
                        language: selectedLanguage,
                    })
                );
            }
        }
    };

    const handleLogout = async () => {
        _dispatch(setBusy());
        await _dispatch(performLogout());
        setNavVisible(false);
        _history.push(WebUrl._URL_MAIN);
        _dispatch(setIdle());
    }

    const handleOnClick = async (item) => {
        if (item.isLogout) {
            handleLogout();
            setNavVisible(false);
            return;
        }

        if (item.isLang) {
            setShowNavCountry(true);
            setNavVisible(false);
            setSelectedSubMenu(0);
        } else if (item.isOfficialLink) {
            setShowNavOfficialLinks(true);
            setNavVisible(false);
            setSelectedSubMenu(0);
        } else if (item.isBigWinning) {
            _dispatch(setIsShowBigWinning(true));
            updateMemberBigWinningViewHistoryCount();
        }
        else if (item.isVip && location.pathname !== item.url) {
            if (_userData.isCreateShareHolderPin) {
                _dispatch(setIsShowCreateShareHolderPin(true));
                _dispatch(setIsShowVerifyShareHolderPin(false));
            } else {
                _dispatch(setIsShowCreateShareHolderPin(false));
                _dispatch(setIsShowVerifyShareHolderPin(true));
            }
            setNavVisible(false);
            setSelectedSubMenu(0);
        }
        else {
            if (item.subList && item.subList.length > 0) {
                setSelectedSubMenu(item.subMenuId);
            } else {
                if (item.openNewWindow) {
                    setNavVisible(false);
                    window.open(item.url, "_blank");
                } else {
                    setNavVisible(false);
                    setSelectedSubMenu(0);
                    _history.replace(item.url);
                }
            }
        }
    }

    // get member special roll over
    const getMemberSpecialRollover = async () => {
        let responseJson = await ApiEngine.get(ApiUrl._API_GET_MEMBER_IS_SPECIAL_ROLLOVER_DATA);
        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            var data = responseJson[ApiKey._API_DATA_KEY];
            _dispatch(updateUserSpecialRollover(data['isSpecialRollover']));
            _dispatch(updateUserRolloverBalance(data['rollOverBalance']));
        }
    }

    //get playdable category
    const getBonusDepositProductCategory = async () => {
        let responseJson = await ApiEngine.get(ApiUrl._API_GET_BONUS_DEPOSIT_PRODUCT_CATEGORY);

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            let data = responseJson[ApiKey._API_DATA_KEY];
            let productCategoryArr = [];

            if (data.includes(",")) {
                productCategoryArr = responseJson[ApiKey._API_DATA_KEY].split(",");
            }
            else {
                productCategoryArr.push(data);
            }

            let tempArr = [];
            productCategory.forEach((x) => {
                if (productCategoryArr.includes(x.value)) {
                    tempArr.push(x.label);
                }
            })
            _dispatch(setPlayableCategory(tempArr));
        }
    }

    //get rollover data
    const getRolloverData = async () => {
        var responseJson = await ApiEngine.get(ApiUrl._API_GET_ROLLOVER_RECORD);

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            let data = responseJson[ApiKey._API_DATA_KEY];
            if (data.length > 0) {
                _dispatch(setRolloverTarget(data[0].rolloverTarget));
            } else {
                _dispatch(setRolloverTarget(0));
            }
        }
    }

    const getRTPUrl = async () => {
        let rtpurl = await ApiEngine.get(ApiUrl._API_GET_RTP_URL);
        if (rtpurl[ApiKey._API_SUCCESS_KEY] && rtpurl[ApiKey._API_DATA_KEY] !== null) {
            _dispatch(setRtpUrl(localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
                rtpurl[ApiKey._API_DATA_KEY] + "?lang=" + localStorage.getItem(SessionKey._LANGUAGE) : rtpurl[ApiKey._API_DATA_KEY] + "?lang=id"));
        }
    }

    const updateMemberBigWinningViewHistoryCount = async () => {
        await ApiEngine.get(ApiUrl._API_UPDATE_MEMBER_BIG_WINNING_VIEW_HISTORY_COUNT);
    }

    const checkInitialLanguage = async () => {
        if (params.get("languageCode") != null) {
            let tempLangCode = params.get("languageCode");
            i18n.changeLanguage(tempLangCode);
            localStorage.setItem(SessionKey._LANGUAGE, tempLangCode);
        }
        else if (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined') {
            if (LanguageOption.find(
                (x) => x.code === localStorage.getItem(SessionKey._LANGUAGE)) != undefined) {
                i18n.changeLanguage(localStorage.getItem(SessionKey._LANGUAGE));
            }
            else {
                i18n.changeLanguage("id");
                localStorage.setItem(SessionKey._LANGUAGE, "id");
            }
        } else {
            i18n.changeLanguage("id");
            localStorage.setItem(SessionKey._LANGUAGE, "id");
        }
    }

    const getHeaderLanguageCode = () =>
        (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
            localStorage.getItem(SessionKey._LANGUAGE) : 'id');

    const applyMobileHeaderGeneralData = (originalData) => {
        let data = originalData['activeProductCategory'];

        let tempArray = [];
        for (var i = 0; i < data.length; i++) {
            if (data[i].originalTitle === "SlotMix" || data[i].originalTitle === "Slots") {
                let hasSlots = tempArray.filter(x => x.originalTitle === "Slots").length > 0;
                if (!hasSlots) {
                    data[i].icon = "/img/ug/sidemenu/slots-ug.svg";
                    data[i].url = WebUrl._URL_PROVIDER_LOBBY.replace(":category", "Slots").replace(":provider?", "");
                    tempArray.push(data[i]);
                }
            } else {
                data[i].icon = "/img/ug/sidemenu/" + data[i].originalTitle.toLowerCase().replace(/\s/g, '') + "-ug.svg";
                data[i].url = WebUrl._URL_PROVIDER_LOBBY.replace(":category", data[i].originalTitle).replace(":provider?", "");
                tempArray.push(data[i]);
            }
        }
        _dispatch(setProductCategoryGameList(tempArray));
        _dispatch(setRtpUrl(originalData['rtpUrl'] + "?lang=" + getHeaderLanguageCode()));
        _dispatch(setCommunicationChannelList(originalData['channels']));
        _dispatch(setIsNonSeamlessGameExist(originalData['isNonSeamlessMasterProduct']));

        let tempArray2 = [];
        let data2 = originalData['productCategories'];
        data2.forEach(x => {
            if (x.id > 0) {
                tempArray2.push({ value: x.id.toString(), label: x.title });
            }
        });
        _dispatch(setProductCategory(tempArray2));
        setCompanyOfficialLinks(originalData["officialLinks"]);
        setDisplayOfficialLinks(originalData["officialLinks"].filter(x => isLoggedIn ? true : !x.testing));
        setFirstLoad(false);
    };

    const getMobileHeaderGeneralData = async (force = false) => {
        const languageCode = getHeaderLanguageCode();
        const cacheKey = CacheKeys.mobileHeaderGeneral(languageCode);

        if (!force) {
            const cached = getSessionCache(cacheKey);
            if (cached) {
                applyMobileHeaderGeneralData(cached);
                return;
            }
        }

        _dispatch(setBusy());
        let responseJson = await ApiEngine.get(ApiUrl._API_UG_GET_MOBILE_HEADER_GENERAL_DATA + "?languageCode=" + languageCode);

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            let originalData = responseJson[ApiKey._API_DATA_KEY];
            setSessionCache(cacheKey, originalData);
            applyMobileHeaderGeneralData(originalData);
        }
        else {
            _dispatch(
                showResponseMessage(false, responseJson[ApiKey._API_MESSAGE_KEY])
            );
        }
        _dispatch(setIdle());
    }

    const getMobileHeaderAuthData = async () => {
        _dispatch(setBusy());
        let responseJson = await ApiEngine.get(ApiUrl._API_UG_GET_MOBILE_HEADER_AUTH_DATA + "?languageCode=" +
            (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
                localStorage.getItem(SessionKey._LANGUAGE) : 'id'));

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            let originalData = responseJson[ApiKey._API_DATA_KEY];
            let data = originalData['activeProductCategory']

            let tempArray = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].originalTitle === "SlotMix" || data[i].originalTitle === "Slots") {
                    let hasSlots = tempArray.filter(x => x.originalTitle === "Slots").length > 0;
                    if (!hasSlots) {
                        data[i].icon = "/img/ug/sidemenu/slots-ug.svg";
                        data[i].url = WebUrl._URL_PROVIDER_LOBBY.replace(":category", "Slots").replace(":provider?", "");
                        tempArray.push(data[i]);
                    }
                } else {
                    data[i].icon = "/img/ug/sidemenu/" + data[i].originalTitle.toLowerCase().replace(/\s/g, '') + "-ug.svg";
                    data[i].url = WebUrl._URL_PROVIDER_LOBBY.replace(":category", data[i].originalTitle).replace(":provider?", "");
                    tempArray.push(data[i]);
                }
            }
            _dispatch(setProductCategoryGameList(tempArray));
            _dispatch(setIsNonSeamlessGameExist(originalData['isNonSeamlessMasterProduct']));


            let tempArray2 = [];
            let data2 = originalData['productCategories'];
            data2.forEach(x => {
                if (x.id > 0) {
                    tempArray2.push({ value: x.id.toString(), label: x.title });
                }
            });
            _dispatch(setProductCategory(tempArray2));
        } else {
            _dispatch(
                showResponseMessage(false, responseJson[ApiKey._API_MESSAGE_KEY])
            );

        }
        _dispatch(setIdle());
    }

    const getMobileHeaderLanguageData = async () => {
        _dispatch(setBusy());
        let responseJson = await ApiEngine.get(ApiUrl._API_UG_GET_MOBILE_HEADER_LANGUAGE_DATA + "?languageCode=" +
            (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
                localStorage.getItem(SessionKey._LANGUAGE) : 'id'));

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            let originalData = responseJson[ApiKey._API_DATA_KEY];
            let data = originalData['activeProductCategory']

            let tempArray = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].originalTitle === "SlotMix" || data[i].originalTitle === "Slots") {
                    let hasSlots = tempArray.filter(x => x.originalTitle === "Slots").length > 0;
                    if (!hasSlots) {
                        data[i].icon = "/img/ug/sidemenu/slots-ug.svg";
                        data[i].url = WebUrl._URL_PROVIDER_LOBBY.replace(":category", "Slots").replace(":provider?", "");
                        tempArray.push(data[i]);
                    }
                } else {
                    data[i].icon = "/img/ug/sidemenu/" + data[i].originalTitle.toLowerCase().replace(/\s/g, '') + "-ug.svg";
                    data[i].url = WebUrl._URL_PROVIDER_LOBBY.replace(":category", data[i].originalTitle).replace(":provider?", "");
                    tempArray.push(data[i]);
                }
            }
            _dispatch(setProductCategoryGameList(tempArray));
            _dispatch(setRtpUrl(localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
                originalData['rtpUrl'] + "?lang=" + localStorage.getItem(SessionKey._LANGUAGE) : originalData['rtpUrl'] + "?lang=id"));
            let tempArray2 = [];
            let data2 = originalData['productCategories'];
            data2.forEach(x => {
                if (x.id > 0) {
                    tempArray2.push({ value: x.id.toString(), label: x.title });
                }
            });
            _dispatch(setProductCategory(tempArray2));
            setFirstLoad(false);
        }
        else {
            _dispatch(
                showResponseMessage(false, responseJson[ApiKey._API_MESSAGE_KEY])
            );
        }
        _dispatch(setIdle());
    }



    return (
        <>
            <div id="new-header">
                <div className="header-lang-nav-container">
                    <div>
                        <LazyLoadImage src={"/img/ug/header/hamburger.png"} width="20" height="21" alt="arrow" onClick={() => setNavVisible(true)} />
                    </div>
                    <div style={{ display: "flex", alignItems: "baseline" }} onClick={() => { _history.push(WebUrl._URL_MAIN) }}>
                        <LazyLoadImage src={"/img/ug/icon/i8.live_2026.webp"} style={{ height: "30px", width: "75px" }} alt="arrow" />
                    </div>
                    <div className="header-profile-benefit">
                        <div className="mr-2">
                            <LazyLoadImage src={"/img/ug/header/gift.svg"} width="25" height="25" alt="arrow" onClick={() => {
                                if (isLoggedIn) {
                                    _history.push(WebUrl._URL_MEMBER_BENEFIT_PAGE);
                                } else {
                                   _dispatch(setDisplayLogin(true))
                                }
                            }} />
                        </div>
                        <div>
                            <LazyLoadImage src={"/img/ug/header/profile.svg"} width="25" height="25" alt="arrow" onClick={() => {
                                if (isLoggedIn) {
                                    /*_history.push(WebUrl._URL_SETTINGS);*/
                                    _dispatch(setDisplayProfile(true))
                                } else {
                                    _dispatch(setDisplayLogin(true))
                                }
                            }} />
                        </div>

                    </div>
                    <Auth />
                </div>
            </div>


            <Modal
                id="nav-modal"
                fade={false}
                isOpen={navVisible}
                toggle={() => {
                    setNavVisible(false);
                    setSelectedSubMenu(0);
                }}
            >
                <ModalBody>
                    <div className="ug-side-menu-container">
                        {newNavList &&
                            newNavList.length &&
                            newNavList.filter(x => !isLoggedIn ? !x.requiredAuth : _userData.isShareHolder ? x : !x.isVip)
                            .filter(x => displayOfficialLinks.length > 0 ? true : x.title !== t("OFFICIAL_LINK"))
                            .map((item, index) => {
                                return (
                                    <div key={index} onClick={() => { handleOnClick(item) }} className={(selectedSubMenu === item.subMenuId && item.onActivePage) || (item.onActivePage && location.pathname === item.url) ? "ug-side-menu-item-container active" : "ug-side-menu-item-container"} >
                                        <div className="ug-side-menu-item">
                                            <div className="ug-side-menu-image">
                                                <LazyLoadImage
                                                    src={item.icon}
                                                    className={item.isBigWinning ? "img-responsive" : "img-responsive ug-side-menu-image-icon"}
                                                    alt={item.title + " i8"}
                                                />
                                                {item.hot && (
                                                    <>
                                                        <div className="header-category-tag">
                                                            <LazyLoadImage
                                                                src={"/img/ug/sidemenu/hot.svg"}
                                                                className="img-responsive"
                                                                alt="hot games i8"
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {item.new && (
                                                    <>
                                                        <div className="header-category-tag">
                                                            <LazyLoadImage
                                                                src={"/img/ug/sidemenu/new.svg"}
                                                                className="img-responsive"
                                                                alt="new games i8"
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                            <div className="ug-side-menu-title">{item.title}</div>
                                        </div>
                                        {item.subList && item.subList.length > 0 && selectedSubMenu === item.subMenuId &&
                                            <div className={selectedSubMenu === item.subMenuId ? "ug-sub-menu-container open" : "ug-sub-menu-container"}>
                                                {item.subList.filter(j => j.isDisplay).map((item2, index) => {
                                                    return (
                                                        <div key={index} onClick={() => { handleOnClick(item2) }} className={item2.onActivePage && location.pathname === item2.url ? "ug-sub-menu-item-container active" : "ug-sub-menu-item-container"} >
                                                            <div className="ug-sub-menu-item">
                                                                <div className="ug-sub-menu-image">
                                                                    <LazyLoadImage
                                                                        src={(item2.icon)}
                                                                        className="img-responsive ug-sub-menu-image-icon"
                                                                        alt={item2.title + " i8"}
                                                                    />
                                                                    {item2.isHot && (
                                                                        <>
                                                                            <div className="header-category-tag">
                                                                                <LazyLoadImage
                                                                                    src={"/img/ug/sidemenu/hot.svg"}
                                                                                    className="img-responsive"
                                                                                    alt="hot games i8"
                                                                                />
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                    {item2.isNew && (
                                                                        <>
                                                                            <div className="header-category-tag">
                                                                                <LazyLoadImage
                                                                                    src={"/img/ug/sidemenu/new.svg"}
                                                                                    className="img-responsive"
                                                                                    alt="new games i8"
                                                                                />
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                                <div className="header-category-img-title">{item2.title}</div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                </ModalBody>
            </Modal>
            <Modal
                id="lang-modal"
                fade={true}
                isOpen={showNavCountry}
                toggle={() => {
                    setShowNavCountry(false)
                }}
                centered
            >
                <ModalBody>

                    <div className="country-dropdown-container" style={showNavCountry ? { display: 'block' } : { display: 'none' }}>
                        <div className="language-title">{t("REGION_AND_LANGUAGE")}</div>
                        {countryList.filter(x => isLoggedIn ? x.iso === 'ID' : x) &&
                            countryList.filter(x => isLoggedIn ? x.iso === 'ID' : x).length &&
                            map(countryList.filter(x => isLoggedIn ? x.iso === 'ID' : x), (item, index) => {
                                return (
                                    <div key={index}>
                                        <div className={"country-row-container" + (selectionLangHeaderOption.name == item.name ? " active" : " ")}>
                                            <div className="country-dropdown-items">
                                                <div className="first">
                                                    <div>
                                                        <img
                                                            style={{ width: "18px" }}
                                                            src={item.icon}
                                                            alt={item.name}
                                                        />
                                                    </div>
                                                    <div>
                                                        {item.name}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="country-child-container">
                                                {item.child_languages &&
                                                    item.child_languages.length &&
                                                    map(item.child_languages, (child, index) => {
                                                        return (
                                                            <div key={index}>
                                                                <div onClick={() => handleCountryOnClick(item, child.languageCode)} className={'country-child-lang' + (selectionLangHeaderOption.name === item.name && activeLanguage === child.languageCode ? ' active' : '')}>
                                                                    {child.name}
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>

                </ModalBody>
            </Modal>
            <Modal
                id="official-link-modal"
                fade={true}
                isOpen={showNavOfficialLinks}
                toggle={() => {
                    setShowNavOfficialLinks(false)
                }}
                centered
            >
                <ModalBody>
                    <div className="country-dropdown-container" style={showNavOfficialLinks ? { display: 'block' } : { display: 'none' }}>
                        <div className="language-title">{t("OFFICIAL_LINK")}</div>
                            <div className="link-btn-wrapper">
                                {map(displayOfficialLinks, (item, index) => {
                                    return (
                                        <div key={index} className="link-btn">
                                            <div onClick={() => { window.location.href = item.link; }}>
                                                {item.name.startsWith("OFFICIAL LINK") ? t("OFFICIAL_LINK") + " " + (index+1) : item.displayText}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                    </div>

                </ModalBody>
            </Modal>
            <BigWinningModal />
            <ShareHolderAuth />
            <NonSeamlessGameWalletModal />
        </>
    );
});

export default Header;
